<template>
  <el-form
    label-position="top"
    :model="form"
    :rules="rules"
    ref="form"
    class="text-left"
  >
    <el-row :gutter="30">
      <el-col :span="24" :md="12">
        <el-form-item
          :label="`ระยะเวลาในการเปิด-ปิดแบบทดสอบ${textTest}`"
          prop="courseTestDistanceDate"
          class="line-unset"
        >
          <el-date-picker
            v-model="form.courseTestDistanceDate"
            type="daterange"
            class="width-100 show-in-desktop"
            range-separator="ถึง"
            start-placeholder=""
            end-placeholder=""
            format="d MMMM yyyy"
            :picker-options="{
              disabledDate(time) {
                return (
                  time.getTime() < new Date(startDate).getTime() ||
                  time.getTime() > new Date(endDate).getTime()
                );
              },
            }"
          >
          </el-date-picker>
          <div class="flex-display js-between show-in-desktop">
            <span class="color-gray line-initial text-font-12">เวลา 0.00 น.</span>
            <span class="color-gray line-initial text-font-12">เวลา 23.59 น.</span>
          </div>


          <el-date-picker
            v-model="form.courseTestDistanceDate[0]"
            type="date"
            format="d MMMM yyyy"
            class="show-in-mobile width-100"
            :picker-options="{
              disabledDate(time) {
                return (
                  time.getTime() >
                  new Date(form.courseTestDistanceDate[1]).getTime() ||
                  time.getTime() < new Date(startDate).getTime() ||
                  time.getTime() > new Date(endDate).getTime()
                );
              },
            }"
          >
          </el-date-picker>
          <span class="color-gray line-initial text-font-12 show-in-mobile">เวลา 0.00 น.</span>

          <el-date-picker
            v-model="form.courseTestDistanceDate[1]"
            type="date"
            format="d MMMM yyyy"
            class="show-in-mobile mg-t-4 width-100"
            :picker-options="{
              disabledDate(time) {
                return (
                  time.getTime() <
                  new Date(form.courseTestDistanceDate[0]).getTime() ||
                  time.getTime() < new Date(startDate).getTime() ||
                  time.getTime() > new Date(endDate).getTime()
                );
              },
            }"
          >
          </el-date-picker>
          <span class="color-gray line-initial text-font-12 show-in-mobile">เวลา 23.59 น.</span>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item
          :label="`คำถามแบบทดสอบ${textTest}`"
          prop="courseTestQuestion"
        >
          <yimo-vue-editor
            v-model="form.courseTestQuestion"
            @input="checkValid('courseTestQuestion')"
          ></yimo-vue-editor>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <div class="position-relative">
          <p
            @click="form.correct = 1"
            class="text-font-14 correct-text"
            :class="{ active: form.correct == 1 }"
            style="color: #33a0f4"
          >
            คำตอบที่ถูกต้อง
          </p>
          <el-form-item label="ตัวเลือกคำตอบข้อที่ 1" prop="answer1">
            <el-input v-model="form.answer1"></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="position-relative">
          <p
            @click="form.correct = 2"
            class="text-font-14 correct-text"
            :class="{ active: form.correct == 2 }"
            style="color: #33a0f4"
          >
            คำตอบที่ถูกต้อง
          </p>
          <el-form-item label="ตัวเลือกคำตอบข้อที่ 2" prop="answer2">
            <el-input v-model="form.answer2"></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="position-relative">
          <p
            @click="form.correct = 3"
            class="text-font-14 correct-text"
            :class="{ active: form.correct == 3 }"
            style="color: #33a0f4"
          >
            คำตอบที่ถูกต้อง
          </p>
          <el-form-item label="ตัวเลือกคำตอบข้อที่ 3" prop="answer3">
            <el-input v-model="form.answer3"></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="position-relative">
          <p
            @click="form.correct = 4"
            class="text-font-14 correct-text"
            :class="{ active: form.correct == 4 }"
            style="color: #33a0f4"
          >
            คำตอบที่ถูกต้อง
          </p>
          <el-form-item label="ตัวเลือกคำตอบข้อที่ 4" prop="answer4">
            <el-input v-model="form.answer4"></el-input>
          </el-form-item>
        </div>
      </el-col>
    </el-row>

    <div class="text-center pd-y-3">
      <el-button
        v-if="type == 'add'"
        @click="createCourseTest"
        type="primary"
        round
        class="pd-x-1"
        >เพิ่มข้อสอบ</el-button
      >
      <el-button
        v-if="type == 'update'"
        @click="updateCourseTest"
        type="primary"
        round
        class="pd-x-1"
        >บันทึก</el-button
      >
    </div>
  </el-form>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default() {
        return "add";
      },
    },
    testType: {
      type: String,
      default() {
        return "preTest";
      },
    },
    courseTest: {
      type: Object,
      default() {
        return null;
      },
    },
    startDate: {
      type: String,
      default() {
        return "";
      },
    },
    endDate: {
      type: String,
      default() {
        return "";
      },
    },
    durationTimeTest: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    textTest() {
      return this.testType == "preTest"
        ? "ก่อนเรียน (Pre test)"
        : "หลังเรียน (Post test)";
    },
  },
  data() {
    return {
      form: {
        courseTestDistanceDate: [],
        courseTestQuestion: "",
        answer1: "",
        answer2: "",
        answer3: "",
        answer4: "",
        correct: "",
      },
      rules: {
        courseTestDistanceDate: [
          {
            required: true,
            message: `กรุณาเลือกระยะเวลาในการเปิด-ปิดแบบทดสอบ${
              this.testType == "preTest" ? "ก่อนเรียน" : "หลังเรียน"
            }`,
            trigger: ["blur", "change"],
          },
        ],
        courseTestQuestion: [
          {
            required: true,
            message: `กรุณากรอกคำถามแบบทดสอบ${
              this.testType == "preTest" ? "ก่อนเรียน" : "หลังเรียน"
            }`,
            trigger: "blur",
          },
        ],
        answer1: [
          {
            required: true,
            message: "กรุณากรอกตัวเลือกคำตอบข้อที่ 1",
            trigger: "blur",
          },
        ],
        answer2: [
          {
            required: true,
            message: "กรุณากรอกตัวเลือกคำตอบข้อที่ 2",
            trigger: "blur",
          },
        ],
        answer3: [
          {
            required: true,
            message: "กรุณากรอกตัวเลือกคำตอบข้อที่ 3",
            trigger: "blur",
          },
        ],
        answer4: [
          {
            required: true,
            message: "กรุณากรอกตัวเลือกคำตอบข้อที่ 4",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    courseTest() {
      this.setCourseTest();
    },
  },
  mounted() {
    this.setCourseTest();
  },
  methods: {
    setCourseTest() {
      if (this.courseTest != null) {
        let index = this.courseTest.answers.findIndex(
          (answers) => answers.correct == true
        );

        this.form = {
          courseTestDistanceDate:(this.durationTimeTest)?[
            this.durationTimeTest.open,
            this.durationTimeTest.close
          ]:[],
          courseTestQuestion: this.courseTest.question,
          answer1: this.courseTest.answers[0].text,
          answer2: this.courseTest.answers[1].text,
          answer3: this.courseTest.answers[2].text,
          answer4: this.courseTest.answers[3].text,
          correct: index > -1 ? index + 1 : "",
        };
      }

      if (this.durationTimeTest && this.durationTimeTest.open && this.durationTimeTest.close) {
         this.form.courseTestDistanceDate =[this.durationTimeTest.open,this.durationTimeTest.close]
      }
    },
    createCourseTest() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.correct != "") {
            this.$emit("createCourseTest", this.form);
          } else {
            this.$message.error("กรุณาเลือกคำตอบ");
          }
        }
      });
    },
    updateCourseTest() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.correct != "") {
            this.$emit("updateCourseTest", this.form);
          } else {
            this.$message.error("กรุณาเลือกคำตอบ");
          }
        }
      });
    },
    checkValid(field) {
      if (this.$options.filters.striphtml(this.form.courseTestQuestion) == "") {
        this.form.courseTestQuestion = "";
      }
      this.$refs["form"].validateField(field);
    },
  },
};
</script>

<style scoped>
.correct-text {
  position: absolute;
  right: 0;
  top: -8px;
  cursor: pointer;
}
.correct-text:hover {
  color: #00b37d;
}
.correct-text.active {
  color: #00b37d !important;
}
</style>
